const $inject = ['$filter', 'settingsService', 'ENUMS'];

const dateTimeService = function ($filter, settingsService, ENUMS) {
  let service = {};

  const FILE_DATE_FORMAT_SHORT = $filter('translate')('dates.DateFormat');
  const FILE_DATE_FORMAT_MEDIUM = $filter('translate')('dates.DateFormatMedium');
  const FILE_DATE_FORMAT_LONG = $filter('translate')('dates.DateFormatLong');
  const FILE_TIME_FORMAT_LONG = $filter('translate')('dates.TimeFormatLong');
  const FILE_DATE_TIME_FORMAT_LONG = $filter('translate')('dates.DateTimeFormatLong');

  service.getFormat = getFormat;

  function getFormat(enumValue) {
    const dateTimeConfiguration = settingsService.settings.DateTimeConfiguration;
    switch (enumValue) {
      case ENUMS.dateTimeFormats.DATE_SHORT:
        return dateTimeConfiguration.DateFormatShort ? dateTimeConfiguration.DateFormatShort : FILE_DATE_FORMAT_SHORT;

      case ENUMS.dateTimeFormats.DATE_MEDIUM:
        return dateTimeConfiguration.DateFormatMedium ? dateTimeConfiguration.DateFormatMedium : FILE_DATE_FORMAT_MEDIUM;

      case ENUMS.dateTimeFormats.DATE_LONG:
        return dateTimeConfiguration.DateFormatLong ? dateTimeConfiguration.DateFormatLong : FILE_DATE_FORMAT_LONG;

      case ENUMS.dateTimeFormats.TIME_LONG:
        return dateTimeConfiguration.TimeFormatLong ? dateTimeConfiguration.TimeFormatLong : FILE_TIME_FORMAT_LONG;

      case ENUMS.dateTimeFormats.DATE_TIME_LONG:
        return dateTimeConfiguration.DateTimeFormat ? dateTimeConfiguration.DateTimeFormat : FILE_DATE_TIME_FORMAT_LONG;

      default:
        throw new Error('Invalid dateTime format required in dateTimeService.getFormat');
    }
  }

  service.getMinutesFromTime = getMinutesFromTime;
  function getMinutesFromTime(time) {
    const timeParts = time.split(':');
    return parseInt(timeParts[0], 10) * 60 + parseInt(timeParts[1], 10);
  }

  return service;
};

dateTimeService.$inject = $inject;

export default dateTimeService;



// WEBPACK FOOTER //
// ./src/services/dateTimeService.js